export const PRESCRIPTION_TEST_OPTIONS = [
    {
      label: "+1",
      value: "+1",
    },
    {
      label: "+2",
      value: "+2",
    },
    {
      label: "+3",
      value: "+3",
    },
    {
      label: "+4",
      value: "+4",
    },
    {
      label: "+5",
      value: "+5",
    },
  ];
  
  export const SPH_OPTIONS = [
    {
        "label": " ",
        "value": " "
    },
    {
        "label": "-20.00",
        "value": "-20.00"
    },
    {
        "label": "-20.00",
        "value": "-20.00"
    },
    {
        "label": "-19.75",
        "value": "-19.75"
    },
    {
        "label": "-19.50",
        "value": "-19.50"
    },
    {
        "label": "-19.25",
        "value": "-19.25"
    },
    {
        "label": "-19.00",
        "value": "-19.00"
    },
    {
        "label": "-18.75",
        "value": "-18.75"
    },
    {
        "label": "-18.50",
        "value": "-18.50"
    },
    {
        "label": "-18.25",
        "value": "-18.25"
    },
    {
        "label": "-18.00",
        "value": "-18.00"
    },
    {
        "label": "-17.75",
        "value": "-17.75"
    },
    {
        "label": "-17.50",
        "value": "-17.50"
    },
    {
        "label": "-17.25",
        "value": "-17.25"
    },
    {
        "label": "-17.00",
        "value": "-17.00"
    },
    {
        "label": "-16.75",
        "value": "-16.75"
    },
    {
        "label": "-16.50",
        "value": "-16.50"
    },
    {
        "label": "-16.25",
        "value": "-16.25"
    },
    {
        "label": "-16.00",
        "value": "-16.00"
    },
    {
        "label": "-15.75",
        "value": "-15.75"
    },
    {
        "label": "-15.50",
        "value": "-15.50"
    },
    {
        "label": "-15.25",
        "value": "-15.25"
    },
    {
        "label": "-15.00",
        "value": "-15.00"
    },
    {
        "label": "-14.75",
        "value": "-14.75"
    },
    {
        "label": "-14.50",
        "value": "-14.50"
    },
    {
        "label": "-14.25",
        "value": "-14.25"
    },
    {
        "label": "-14.00",
        "value": "-14.00"
    },
    {
        "label": "-13.75",
        "value": "-13.75"
    },
    {
        "label": "-13.50",
        "value": "-13.50"
    },
    {
        "label": "-13.25",
        "value": "-13.25"
    },
    {
        "label": "-13.00",
        "value": "-13.00"
    },
    {
        "label": "-12.75",
        "value": "-12.75"
    },
    {
        "label": "-12.50",
        "value": "-12.50"
    },
    {
        "label": "-12.25",
        "value": "-12.25"
    },
    {
        "label": "-12.00",
        "value": "-12.00"
    },
    {
        "label": "-11.75",
        "value": "-11.75"
    },
    {
        "label": "-11.50",
        "value": "-11.50"
    },
    {
        "label": "-11.25",
        "value": "-11.25"
    },
    {
        "label": "-11.00",
        "value": "-11.00"
    },
    {
        "label": "-10.75",
        "value": "-10.75"
    },
    {
        "label": "-10.50",
        "value": "-10.50"
    },
    {
        "label": "-10.25",
        "value": "-10.25"
    },
    {
        "label": "-10.00",
        "value": "-10.00"
    },
    {
        "label": "-9.75",
        "value": "-9.75"
    },
    {
        "label": "-9.50",
        "value": "-9.50"
    },
    {
        "label": "-9.25",
        "value": "-9.25"
    },
    {
        "label": "-9.00",
        "value": "-9.00"
    },
    {
        "label": "-8.75",
        "value": "-8.75"
    },
    {
        "label": "-8.50",
        "value": "-8.50"
    },
    {
        "label": "-8.25",
        "value": "-8.25"
    },
    {
        "label": "-8.00",
        "value": "-8.00"
    },
    {
        "label": "-7.75",
        "value": "-7.75"
    },
    {
        "label": "-7.50",
        "value": "-7.50"
    },
    {
        "label": "-7.25",
        "value": "-7.25"
    },
    {
        "label": "-7.00",
        "value": "-7.00"
    },
    {
        "label": "-6.75",
        "value": "-6.75"
    },
    {
        "label": "-6.50",
        "value": "-6.50"
    },
    {
        "label": "-6.25",
        "value": "-6.25"
    },
    {
        "label": "-6.00",
        "value": "-6.00"
    },
    {
        "label": "-5.75",
        "value": "-5.75"
    },
    {
        "label": "-5.50",
        "value": "-5.50"
    },
    {
        "label": "-5.25",
        "value": "-5.25"
    },
    {
        "label": "-5.00",
        "value": "-5.00"
    },
    {
        "label": "-4.75",
        "value": "-4.75"
    },
    {
        "label": "-4.50",
        "value": "-4.50"
    },
    {
        "label": "-4.25",
        "value": "-4.25"
    },
    {
        "label": "-4.00",
        "value": "-4.00"
    },
    {
        "label": "-3.75",
        "value": "-3.75"
    },
    {
        "label": "-3.50",
        "value": "-3.50"
    },
    {
        "label": "-3.25",
        "value": "-3.25"
    },
    {
        "label": "-3.00",
        "value": "-3.00"
    },
    {
        "label": "-2.75",
        "value": "-2.75"
    },
    {
        "label": "-2.50",
        "value": "-2.50"
    },
    {
        "label": "-2.25",
        "value": "-2.25"
    },
    {
        "label": "-2.00",
        "value": "-2.00"
    },
    {
        "label": "-1.75",
        "value": "-1.75"
    },
    {
        "label": "-1.50",
        "value": "-1.50"
    },
    {
        "label": "-1.25",
        "value": "-1.25"
    },
    {
        "label": "-1.00",
        "value": "-1.00"
    },
    {
        "label": "-0.75",
        "value": "-0.75"
    },
    {
        "label": "-0.50",
        "value": "-0.50"
    },
    {
        "label": "-0.25",
        "value": "-0.25"
    },
    {
        "label": "+0.00",
        "value": "+0.00"
    },
    {
        "label": "+0.25",
        "value": "+0.25"
    },
    {
        "label": "+0.50",
        "value": "+0.50"
    },
    {
        "label": "+0.75",
        "value": "+0.75"
    },
    {
        "label": "+1.00",
        "value": "+1.00"
    },
    {
        "label": "+1.25",
        "value": "+1.25"
    },
    {
        "label": "+1.50",
        "value": "+1.50"
    },
    {
        "label": "+1.75",
        "value": "+1.75"
    },
    {
        "label": "+2.00",
        "value": "+2.00"
    },
    {
        "label": "+2.25",
        "value": "+2.25"
    },
    {
        "label": "+2.50",
        "value": "+2.50"
    },
    {
        "label": "+2.75",
        "value": "+2.75"
    },
    {
        "label": "+3.00",
        "value": "+3.00"
    },
    {
        "label": "+3.25",
        "value": "+3.25"
    },
    {
        "label": "+3.50",
        "value": "+3.50"
    },
    {
        "label": "+3.75",
        "value": "+3.75"
    },
    {
        "label": "+4.00",
        "value": "+4.00"
    },
    {
        "label": "+4.25",
        "value": "+4.25"
    },
    {
        "label": "+4.50",
        "value": "+4.50"
    },
    {
        "label": "+4.75",
        "value": "+4.75"
    },
    {
        "label": "+5.00",
        "value": "+5.00"
    },
    {
        "label": "+5.25",
        "value": "+5.25"
    },
    {
        "label": "+5.50",
        "value": "+5.50"
    },
    {
        "label": "+5.75",
        "value": "+5.75"
    },
    {
        "label": "+6.00",
        "value": "+6.00"
    },
    {
        "label": "+6.25",
        "value": "+6.25"
    },
    {
        "label": "+6.50",
        "value": "+6.50"
    },
    {
        "label": "+6.75",
        "value": "+6.75"
    },
    {
        "label": "+7.00",
        "value": "+7.00"
    },
    {
        "label": "+7.25",
        "value": "+7.25"
    },
    {
        "label": "+7.50",
        "value": "+7.50"
    },
    {
        "label": "+7.75",
        "value": "+7.75"
    },
    {
        "label": "+8.00",
        "value": "+8.00"
    },
    {
        "label": "+8.25",
        "value": "+8.25"
    },
    {
        "label": "+8.50",
        "value": "+8.50"
    },
    {
        "label": "+8.75",
        "value": "+8.75"
    },
    {
        "label": "+9.00",
        "value": "+9.00"
    },
    {
        "label": "+9.25",
        "value": "+9.25"
    },
    {
        "label": "+9.50",
        "value": "+9.50"
    },
    {
        "label": "+9.75",
        "value": "+9.75"
    },
    {
        "label": "+10.00",
        "value": "+10.00"
    },
    {
        "label": "+10.25",
        "value": "+10.25"
    },
    {
        "label": "+10.50",
        "value": "+10.50"
    },
    {
        "label": "+10.75",
        "value": "+10.75"
    },
    {
        "label": "+11.00",
        "value": "+11.00"
    },
    {
        "label": "+11.25",
        "value": "+11.25"
    },
    {
        "label": "+11.50",
        "value": "+11.50"
    },
    {
        "label": "+11.75",
        "value": "+11.75"
    },
    {
        "label": "+12.00",
        "value": "+12.00"
    },
    {
        "label": "+12.25",
        "value": "+12.25"
    },
    {
        "label": "+12.50",
        "value": "+12.50"
    },
    {
        "label": "+12.75",
        "value": "+12.75"
    },
    {
        "label": "+13.00",
        "value": "+13.00"
    },
    {
        "label": "+13.25",
        "value": "+13.25"
    },
    {
        "label": "+13.50",
        "value": "+13.50"
    },
    {
        "label": "+13.75",
        "value": "+13.75"
    },
    {
        "label": "+14.00",
        "value": "+14.00"
    },
    {
        "label": "+14.25",
        "value": "+14.25"
    },
    {
        "label": "+14.50",
        "value": "+14.50"
    },
    {
        "label": "+14.75",
        "value": "+14.75"
    },
    {
        "label": "+15.00",
        "value": "+15.00"
    },
    {
        "label": "+15.25",
        "value": "+15.25"
    },
    {
        "label": "+15.50",
        "value": "+15.50"
    },
    {
        "label": "+15.75",
        "value": "+15.75"
    },
    {
        "label": "+16.00",
        "value": "+16.00"
    },
    {
        "label": "+16.25",
        "value": "+16.25"
    },
    {
        "label": "+16.50",
        "value": "+16.50"
    },
    {
        "label": "+16.75",
        "value": "+16.75"
    },
    {
        "label": "+17.00",
        "value": "+17.00"
    },
    {
        "label": "+17.25",
        "value": "+17.25"
    },
    {
        "label": "+17.50",
        "value": "+17.50"
    },
    {
        "label": "+17.75",
        "value": "+17.75"
    },
    {
        "label": "+18.00",
        "value": "+18.00"
    },
    {
        "label": "+18.25",
        "value": "+18.25"
    },
    {
        "label": "+18.50",
        "value": "+18.50"
    },
    {
        "label": "+18.75",
        "value": "+18.75"
    },
    {
        "label": "+19.00",
        "value": "+19.00"
    },
    {
        "label": "+19.25",
        "value": "+19.25"
    },
    {
        "label": "+19.50",
        "value": "+19.50"
    },
    {
        "label": "+19.75",
        "value": "+19.75"
    },
    {
        "label": "+20.00",
        "value": "+20.00"
    }
  ];
  
  export const CYL_OPTIONS = [
    {
        "label": " ",
        "value": " "
    },
    {
        "label": "-8.00",
        "value": "-8.00"
    },
    {
        "label": "-8.00",
        "value": "-8.00"
    },
    {
        "label": "-7.75",
        "value": "-7.75"
    },
    {
        "label": "-7.50",
        "value": "-7.50"
    },
    {
        "label": "-7.25",
        "value": "-7.25"
    },
    {
        "label": "-7.00",
        "value": "-7.00"
    },
    {
        "label": "-6.75",
        "value": "-6.75"
    },
    {
        "label": "-6.50",
        "value": "-6.50"
    },
    {
        "label": "-6.25",
        "value": "-6.25"
    },
    {
        "label": "-6.00",
        "value": "-6.00"
    },
    {
        "label": "-5.75",
        "value": "-5.75"
    },
    {
        "label": "-5.50",
        "value": "-5.50"
    },
    {
        "label": "-5.25",
        "value": "-5.25"
    },
    {
        "label": "-5.00",
        "value": "-5.00"
    },
    {
        "label": "-4.75",
        "value": "-4.75"
    },
    {
        "label": "-4.50",
        "value": "-4.50"
    },
    {
        "label": "-4.25",
        "value": "-4.25"
    },
    {
        "label": "-4.00",
        "value": "-4.00"
    },
    {
        "label": "-3.75",
        "value": "-3.75"
    },
    {
        "label": "-3.50",
        "value": "-3.50"
    },
    {
        "label": "-3.25",
        "value": "-3.25"
    },
    {
        "label": "-3.00",
        "value": "-3.00"
    },
    {
        "label": "-2.75",
        "value": "-2.75"
    },
    {
        "label": "-2.50",
        "value": "-2.50"
    },
    {
        "label": "-2.25",
        "value": "-2.25"
    },
    {
        "label": "-2.00",
        "value": "-2.00"
    },
    {
        "label": "-1.75",
        "value": "-1.75"
    },
    {
        "label": "-1.50",
        "value": "-1.50"
    },
    {
        "label": "-1.25",
        "value": "-1.25"
    },
    {
        "label": "-1.00",
        "value": "-1.00"
    },
    {
        "label": "-0.75",
        "value": "-0.75"
    },
    {
        "label": "-0.50",
        "value": "-0.50"
    },
    {
        "label": "-0.25",
        "value": "-0.25"
    },
    {
        "label": "+0.00",
        "value": "+0.00"
    },
    {
        "label": "+0.25",
        "value": "+0.25"
    },
    {
        "label": "+0.50",
        "value": "+0.50"
    },
    {
        "label": "+0.75",
        "value": "+0.75"
    },
    {
        "label": "+1.00",
        "value": "+1.00"
    },
    {
        "label": "+1.25",
        "value": "+1.25"
    },
    {
        "label": "+1.50",
        "value": "+1.50"
    },
    {
        "label": "+1.75",
        "value": "+1.75"
    },
    {
        "label": "+2.00",
        "value": "+2.00"
    },
    {
        "label": "+2.25",
        "value": "+2.25"
    },
    {
        "label": "+2.50",
        "value": "+2.50"
    },
    {
        "label": "+2.75",
        "value": "+2.75"
    },
    {
        "label": "+3.00",
        "value": "+3.00"
    },
    {
        "label": "+3.25",
        "value": "+3.25"
    },
    {
        "label": "+3.50",
        "value": "+3.50"
    },
    {
        "label": "+3.75",
        "value": "+3.75"
    },
    {
        "label": "+4.00",
        "value": "+4.00"
    },
    {
        "label": "+4.25",
        "value": "+4.25"
    },
    {
        "label": "+4.50",
        "value": "+4.50"
    },
    {
        "label": "+4.75",
        "value": "+4.75"
    },
    {
        "label": "+5.00",
        "value": "+5.00"
    },
    {
        "label": "+5.25",
        "value": "+5.25"
    },
    {
        "label": "+5.50",
        "value": "+5.50"
    },
    {
        "label": "+5.75",
        "value": "+5.75"
    },
    {
        "label": "+6.00",
        "value": "+6.00"
    },
    {
        "label": "+6.25",
        "value": "+6.25"
    },
    {
        "label": "+6.50",
        "value": "+6.50"
    },
    {
        "label": "+6.75",
        "value": "+6.75"
    },
    {
        "label": "+7.00",
        "value": "+7.00"
    },
    {
        "label": "+7.25",
        "value": "+7.25"
    },
    {
        "label": "+7.50",
        "value": "+7.50"
    },
    {
        "label": "+7.75",
        "value": "+7.75"
    },
    {
        "label": "+8.00",
        "value": "+8.00"
    }
  ]
  
  export const AXIS_OPTIONS = [
    {
        "label": " ",
        "value": " "
    },
    {
        "label": "000",
        "value": "000"
    },
    {
        "label": "001",
        "value": "001"
    },
    {
        "label": "002",
        "value": "002"
    },
    {
        "label": "003",
        "value": "003"
    },
    {
        "label": "004",
        "value": "004"
    },
    {
        "label": "005",
        "value": "005"
    },
    {
        "label": "006",
        "value": "006"
    },
    {
        "label": "007",
        "value": "007"
    },
    {
        "label": "008",
        "value": "008"
    },
    {
        "label": "009",
        "value": "009"
    },
    {
        "label": "010",
        "value": "010"
    },
    {
        "label": "011",
        "value": "011"
    },
    {
        "label": "012",
        "value": "012"
    },
    {
        "label": "013",
        "value": "013"
    },
    {
        "label": "014",
        "value": "014"
    },
    {
        "label": "015",
        "value": "015"
    },
    {
        "label": "016",
        "value": "016"
    },
    {
        "label": "017",
        "value": "017"
    },
    {
        "label": "018",
        "value": "018"
    },
    {
        "label": "019",
        "value": "019"
    },
    {
        "label": "020",
        "value": "020"
    },
    {
        "label": "021",
        "value": "021"
    },
    {
        "label": "022",
        "value": "022"
    },
    {
        "label": "023",
        "value": "023"
    },
    {
        "label": "024",
        "value": "024"
    },
    {
        "label": "025",
        "value": "025"
    },
    {
        "label": "026",
        "value": "026"
    },
    {
        "label": "027",
        "value": "027"
    },
    {
        "label": "028",
        "value": "028"
    },
    {
        "label": "029",
        "value": "029"
    },
    {
        "label": "030",
        "value": "030"
    },
    {
        "label": "031",
        "value": "031"
    },
    {
        "label": "032",
        "value": "032"
    },
    {
        "label": "033",
        "value": "033"
    },
    {
        "label": "034",
        "value": "034"
    },
    {
        "label": "035",
        "value": "035"
    },
    {
        "label": "036",
        "value": "036"
    },
    {
        "label": "037",
        "value": "037"
    },
    {
        "label": "038",
        "value": "038"
    },
    {
        "label": "039",
        "value": "039"
    },
    {
        "label": "040",
        "value": "040"
    },
    {
        "label": "041",
        "value": "041"
    },
    {
        "label": "042",
        "value": "042"
    },
    {
        "label": "043",
        "value": "043"
    },
    {
        "label": "044",
        "value": "044"
    },
    {
        "label": "045",
        "value": "045"
    },
    {
        "label": "046",
        "value": "046"
    },
    {
        "label": "047",
        "value": "047"
    },
    {
        "label": "048",
        "value": "048"
    },
    {
        "label": "049",
        "value": "049"
    },
    {
        "label": "050",
        "value": "050"
    },
    {
        "label": "051",
        "value": "051"
    },
    {
        "label": "052",
        "value": "052"
    },
    {
        "label": "053",
        "value": "053"
    },
    {
        "label": "054",
        "value": "054"
    },
    {
        "label": "055",
        "value": "055"
    },
    {
        "label": "056",
        "value": "056"
    },
    {
        "label": "057",
        "value": "057"
    },
    {
        "label": "058",
        "value": "058"
    },
    {
        "label": "059",
        "value": "059"
    },
    {
        "label": "060",
        "value": "060"
    },
    {
        "label": "061",
        "value": "061"
    },
    {
        "label": "062",
        "value": "062"
    },
    {
        "label": "063",
        "value": "063"
    },
    {
        "label": "064",
        "value": "064"
    },
    {
        "label": "065",
        "value": "065"
    },
    {
        "label": "066",
        "value": "066"
    },
    {
        "label": "067",
        "value": "067"
    },
    {
        "label": "068",
        "value": "068"
    },
    {
        "label": "069",
        "value": "069"
    },
    {
        "label": "070",
        "value": "070"
    },
    {
        "label": "071",
        "value": "071"
    },
    {
        "label": "072",
        "value": "072"
    },
    {
        "label": "073",
        "value": "073"
    },
    {
        "label": "074",
        "value": "074"
    },
    {
        "label": "075",
        "value": "075"
    },
    {
        "label": "076",
        "value": "076"
    },
    {
        "label": "077",
        "value": "077"
    },
    {
        "label": "078",
        "value": "078"
    },
    {
        "label": "079",
        "value": "079"
    },
    {
        "label": "080",
        "value": "080"
    },
    {
        "label": "081",
        "value": "081"
    },
    {
        "label": "082",
        "value": "082"
    },
    {
        "label": "083",
        "value": "083"
    },
    {
        "label": "084",
        "value": "084"
    },
    {
        "label": "085",
        "value": "085"
    },
    {
        "label": "086",
        "value": "086"
    },
    {
        "label": "087",
        "value": "087"
    },
    {
        "label": "088",
        "value": "088"
    },
    {
        "label": "089",
        "value": "089"
    },
    {
        "label": "090",
        "value": "090"
    },
    {
        "label": "091",
        "value": "091"
    },
    {
        "label": "092",
        "value": "092"
    },
    {
        "label": "093",
        "value": "093"
    },
    {
        "label": "094",
        "value": "094"
    },
    {
        "label": "095",
        "value": "095"
    },
    {
        "label": "096",
        "value": "096"
    },
    {
        "label": "097",
        "value": "097"
    },
    {
        "label": "098",
        "value": "098"
    },
    {
        "label": "099",
        "value": "099"
    },
    {
        "label": "100",
        "value": "100"
    },
    {
        "label": "101",
        "value": "101"
    },
    {
        "label": "102",
        "value": "102"
    },
    {
        "label": "103",
        "value": "103"
    },
    {
        "label": "104",
        "value": "104"
    },
    {
        "label": "105",
        "value": "105"
    },
    {
        "label": "106",
        "value": "106"
    },
    {
        "label": "107",
        "value": "107"
    },
    {
        "label": "108",
        "value": "108"
    },
    {
        "label": "109",
        "value": "109"
    },
    {
        "label": "110",
        "value": "110"
    },
    {
        "label": "111",
        "value": "111"
    },
    {
        "label": "112",
        "value": "112"
    },
    {
        "label": "113",
        "value": "113"
    },
    {
        "label": "114",
        "value": "114"
    },
    {
        "label": "115",
        "value": "115"
    },
    {
        "label": "116",
        "value": "116"
    },
    {
        "label": "117",
        "value": "117"
    },
    {
        "label": "118",
        "value": "118"
    },
    {
        "label": "119",
        "value": "119"
    },
    {
        "label": "120",
        "value": "120"
    },
    {
        "label": "121",
        "value": "121"
    },
    {
        "label": "122",
        "value": "122"
    },
    {
        "label": "123",
        "value": "123"
    },
    {
        "label": "124",
        "value": "124"
    },
    {
        "label": "125",
        "value": "125"
    },
    {
        "label": "126",
        "value": "126"
    },
    {
        "label": "127",
        "value": "127"
    },
    {
        "label": "128",
        "value": "128"
    },
    {
        "label": "129",
        "value": "129"
    },
    {
        "label": "130",
        "value": "130"
    },
    {
        "label": "131",
        "value": "131"
    },
    {
        "label": "132",
        "value": "132"
    },
    {
        "label": "133",
        "value": "133"
    },
    {
        "label": "134",
        "value": "134"
    },
    {
        "label": "135",
        "value": "135"
    },
    {
        "label": "136",
        "value": "136"
    },
    {
        "label": "137",
        "value": "137"
    },
    {
        "label": "138",
        "value": "138"
    },
    {
        "label": "139",
        "value": "139"
    },
    {
        "label": "140",
        "value": "140"
    },
    {
        "label": "141",
        "value": "141"
    },
    {
        "label": "142",
        "value": "142"
    },
    {
        "label": "143",
        "value": "143"
    },
    {
        "label": "144",
        "value": "144"
    },
    {
        "label": "145",
        "value": "145"
    },
    {
        "label": "146",
        "value": "146"
    },
    {
        "label": "147",
        "value": "147"
    },
    {
        "label": "148",
        "value": "148"
    },
    {
        "label": "149",
        "value": "149"
    },
    {
        "label": "150",
        "value": "150"
    },
    {
        "label": "151",
        "value": "151"
    },
    {
        "label": "152",
        "value": "152"
    },
    {
        "label": "153",
        "value": "153"
    },
    {
        "label": "154",
        "value": "154"
    },
    {
        "label": "155",
        "value": "155"
    },
    {
        "label": "156",
        "value": "156"
    },
    {
        "label": "157",
        "value": "157"
    },
    {
        "label": "158",
        "value": "158"
    },
    {
        "label": "159",
        "value": "159"
    },
    {
        "label": "160",
        "value": "160"
    },
    {
        "label": "161",
        "value": "161"
    },
    {
        "label": "162",
        "value": "162"
    },
    {
        "label": "163",
        "value": "163"
    },
    {
        "label": "164",
        "value": "164"
    },
    {
        "label": "165",
        "value": "165"
    },
    {
        "label": "166",
        "value": "166"
    },
    {
        "label": "167",
        "value": "167"
    },
    {
        "label": "168",
        "value": "168"
    },
    {
        "label": "169",
        "value": "169"
    },
    {
        "label": "170",
        "value": "170"
    },
    {
        "label": "171",
        "value": "171"
    },
    {
        "label": "172",
        "value": "172"
    },
    {
        "label": "173",
        "value": "173"
    },
    {
        "label": "174",
        "value": "174"
    },
    {
        "label": "175",
        "value": "175"
    },
    {
        "label": "176",
        "value": "176"
    },
    {
        "label": "177",
        "value": "177"
    },
    {
        "label": "178",
        "value": "178"
    },
    {
        "label": "179",
        "value": "179"
    },
    {
        "label": "180",
        "value": "180"
    }
  ];
  
  export const BASE_1 = [
    {
      label: 'In',
      label: 'In'
    },
    {
      label: 'Out',
      label: 'Out'
    }
  ];
  
  export const BASE_2 = [
    {
      label: 'Up',
      label: 'Up'
    },
    {
      label: 'Down',
      label: 'Down'
    }
  ];